import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

type ActionButtonProps = {
    onClick?: () => void,
    text: string,
    invert?: boolean,
    disabled?: boolean,
    selected?: boolean,
    submit?: boolean
}

export const ActionButton = (props: ActionButtonProps) => {
    const [buttonClass, setButtonClass] = useState('action-button');
    const { selected } = props;

    useEffect(() => {
        if (selected) {
            setButtonClass('action-button action-button-selected');
        } else {
            setButtonClass('action-button ');
        }
    }, [selected]);

    const onClick = useCallback(() => {
        if (!props.disabled && props.onClick) {
            props.onClick();
        }
    }, [props]);

    return (
        <Row className='my-3'>
            <Col>
                <Button className={buttonClass} variant={!props.invert ? 'primary' : 'light'}
                        type={props.submit ? 'submit' : 'button'} size='lg'
                        block onClick={onClick} disabled={props.disabled}>
                    {props.text}
                </Button>
            </Col>
        </Row>
    );

}
